const scrollTop = document.getElementById('scroll__top');

/* Zwei Stufen (Vorgabe Fabian 18.09.2026). Auf den Challenge-Seiten klebt
   die Tableiste auf dem Handy nicht mehr, sie scrollt mit weg. Zurueck
   kommt man hierueber: Steht man unterhalb der Leiste, fuehrt der erste
   Druck dorthin; steht man dort oder darueber, geht es ganz nach oben.
   Seiten ohne Challenge-Section kennen msTabsAnchorY nicht - dort bleibt
   es beim einen Sprung nach oben. */
function msScrollTopZiel() {
  if (typeof window.msTabsAnchorY !== 'function') return 0;
  var anker = window.msTabsAnchorY();
  if (anker == null) return 0;
  return window.scrollY > anker + 8 ? anker : 0;
}
/* Die untere Kapitelleiste der Challenge-Seiten traegt den Pfeil selbst
   und braucht dieselbe Zweistufen-Rechnung. */
window.msScrollTopZiel = msScrollTopZiel;

if (scrollTop) scrollTop.addEventListener('click', function(){
  window.scroll({top: msScrollTopZiel(), left: 0, behavior: 'smooth'});
}) 

window.addEventListener('scroll', function(){
  if(window.scrollY > 300 ){  
    scrollTop.classList.add("active");
  }else{
    scrollTop.classList.remove("active");
  }
}) 